import type { LauncherTarget, LauncherPayload } from './types';

export abstract class BaseLauncherCommunicationController {
  private launcherTargets: LauncherTarget[];
  protected abstract store: unknown;

  constructor() {
    this.launcherTargets = [];
    this.handleIncomingMessage = this.handleIncomingMessage.bind(this);
  }

  protected abstract setStore(store: unknown): void;

  protected abstract handleIncomingMessage(event: MessageEvent): void;

  setTarget(target: LauncherTarget): void {
    this.launcherTargets.push(target);
  }

  removeTarget(tableId: string): void {
    this.launcherTargets = this.launcherTargets.filter((target) => target.tableId !== tableId);
  }

  startListening(): void {
    window.addEventListener('message', this.handleIncomingMessage);
  }

  stopListening(): void {
    window.removeEventListener('message', this.handleIncomingMessage);
  }

  dispatch(message: LauncherPayload | null, tableId?: string, excludeTableId?: boolean): void {
    if (!this.store || !message) return;

    for (const target of this.launcherTargets) {
      const shouldDispatch = !tableId || (excludeTableId ? target.tableId !== tableId : target.tableId === tableId);

      if (shouldDispatch) {
        target.window?.postMessage(message, '*');
      }
    }
  }
}
